module.exports = __webpack_public_path__ + "media/images/app/become-vendor/PlayIconButton-f729d896b5a0476e6463b2da8248fbda.svg";